import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem } from 'reactstrap';
import './NavMenu.css';
import logo from '../images/countylogo.png';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar 
            className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow nav-theme mb-3 p-3"
            dark
            container
        >
            <NavbarBrand href="https://stlouiscountymo.gov">
                <img 
                    src={logo}
                    alt='County Logo'
                    height='50px'
                    className='mr-4 county-logo'
                />
            </NavbarBrand>
            <NavbarBrand className="nav-item" href="/">
                Boards And Commissions
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                <ul className="navbar-nav flex-grow">
                    <NavItem className="text-light nav-link">
                        <a 
                            target="_blank" 
                            href="https://stlouiscountymo.gov/open-data/boards-and-commission-appointments/"
                            rel="noreferrer"
                        >
                            Appointment Tracker
                        </a>
                    </NavItem>
                    <NavItem className="text-light nav-link">
                        <a 
                            target="_blank" 
                            href="https://stlouisco.civicweb.net/Portal/"
                            rel="noreferrer"
                        >
                            Meeting Portal
                        </a>
                    </NavItem>
                    <NavItem className='text-light nav-link'>
                        <a 
                            target="_blank" 
                            href="http://revisor.mo.gov/main/ViewChapter.aspx?chapter=610"
                            rel="noreferrer"
                        >
                            Missouri Sunshine Law
                        </a>
                    </NavItem>
                </ul>
            </Collapse>                            
        </Navbar>
      </header>
    );
  }
}
